import { KpiResult } from '@/api-client/models/utilization/Contracts'
import { COCLASSES } from '@/interfaces/coclass.interface'

export type KpiPerRoomGroup = {
  value: number
  numberOfSpaces: number
  roomGroup: string | undefined
}

export function calculateKpiPerRoomGroup(kpi: KpiResult | undefined): KpiPerRoomGroup[] {
  if (kpi === undefined) return []

  const dataWithGroup: KpiPerRoomGroup[] = (kpi.valuesByRoomType ?? kpi.values).map((values) => {
    const coclass = COCLASSES.find((x) => x.coclass === values.coClass)
    return {
      ...values,
      roomGroup: coclass?.roomGroup
    }
  })

  const distinctRoomGroups = [...new Set(dataWithGroup.map((x) => x.roomGroup))]

  return distinctRoomGroups.map((roomGroup) => {
    const xs = dataWithGroup.filter((x) => x.roomGroup === roomGroup)
    const numberOfSpaces = xs.reduce((acc, item) => acc + item.numberOfSpaces, 0)
    const weightedAverage =
      xs.reduce((acc, item) => acc + item.value * item.numberOfSpaces, 0) / numberOfSpaces

    return {
      value: weightedAverage,
      numberOfSpaces,
      roomGroup
    }
  })
}

export function calculateKpi(kpi: KpiResult | undefined): number | undefined {
  if (kpi === undefined) return undefined
  const grouped = calculateKpiPerRoomGroup(kpi)

  if (grouped.length === 0) return undefined

  const sum = grouped.reduce((acc, item) => acc + item.value * item.numberOfSpaces, 0)
  const numberOfSpaces = grouped.reduce((acc, item) => acc + item.numberOfSpaces, 0)

  return sum / numberOfSpaces
}
